import { useState, useEffect } from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Sections/Home';
import About from './components/Sections/About';
import Services from './components/Sections/Services';
import Events from './components/Sections/Events';
import Contact from './components/Sections/Contact';
import PrivacyPolicy from './components/Sections/PrivacyPolicy';

export default function Portfolio() {
  const [darkMode, setDarkMode] = useState(true);
  const [currentSection, setCurrentSection] = useState('home');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('section');
      const scrollPosition = window.scrollY + 100;
      sections.forEach(section => {
        const sectionTop = section.offsetTop;
        const sectionHeight = section.offsetHeight;
        const sectionId = section.getAttribute('id');
        if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
          setCurrentSection(sectionId);
        }
      });
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      window.scrollTo({ top: section.offsetTop - 80, behavior: 'smooth' });
      setCurrentSection(sectionId);
      setMobileMenuOpen(false);
    }
  };

  return (
    <div className={`min-h-screen transition-colors duration-300 ${darkMode ? 'bg-[#0A0F1E] text-gray-100' : 'bg-[#F8F6F1] text-gray-800'}`}>
      <Header
        darkMode={darkMode}
        currentSection={currentSection}
        scrollToSection={scrollToSection}
        setDarkMode={setDarkMode}
        mobileMenuOpen={mobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
      />
      <div className="lg:pl-20">
        <Home darkMode={darkMode} scrollToSection={scrollToSection} />
        <About darkMode={darkMode} />
        <Events darkMode={darkMode} />
        <Services darkMode={darkMode} scrollToSection={scrollToSection} />
        <Contact darkMode={darkMode} />
        <PrivacyPolicy darkMode={darkMode} />
        <Footer darkMode={darkMode} />
      </div>
    </div>
  );
}